<template>
  <div class="content">
    <!-- 基本信息 -->
    <div class="content-box content-scheme">
      <div class="pay-info" v-if="Object.keys(schemeInfo).length">
        <!--
          甲方代表 总部一样 显示总部应收  显示 总部应收，金额取 甲方授权代表应收金额
          甲方代表 售后一样 显示甲方代表应收 显示甲方授权代表应收 金额取 甲方授权代表应收。
          总部为售后服务公司时，售后公司应收的金额 需累计总部应收中
        -->
        <div v-if="contractInfo.partyAId !== contractInfo.hqId">
          {{ $t('crm_contract_schemeSales_myself.xiao_shou_jin_e') }}：
          <span>{{ schemeInfo.totalAmount }}</span>
        </div>
        <div>
          {{ $t('crm_contract_schemeSales_myself.zong_bu_ying_shou') }}:
          <span v-if="contractInfo.partyAId === contractInfo.hqId&&contractInfo.hqId !== contractInfo.afterServiceId">{{ schemeInfo.totalAmount }}</span>
          <span v-else-if="contractInfo.partyAId !== contractInfo.hqId && contractInfo.hqId === contractInfo.afterServiceId">{{ parseFloat((schemeInfo.hqProfitTotal + schemeInfo.serviceProfitTotal).toFixed(2))  }}</span>
          <span v-else-if="contractInfo.partyAId === contractInfo.hqId && contractInfo.hqId === contractInfo.afterServiceId">{{  schemeInfo.totalAmount }}</span>
          <span v-else>{{ schemeInfo.hqProfitTotal }}</span>
        </div>
        <div v-if="contractInfo.partyAId !== contractInfo.afterServiceId&& contractInfo.hqId !== contractInfo.afterServiceId">
          {{ $t('crm_contract_schemeSales_myself.shou_hou_ying_shou') }}：
          <span>{{ schemeInfo.serviceProfitTotal }}</span>
        </div>
      </div>
      <div class="info">
        <!-- :default-expand-all="true" -->
        <custom-table-expand
          v-loading="isLoading"
          :data="leaseForm.contractList"
          style="width: 100%"
          :rowId="getRowKeys"
          :tableCode="tableCode"
          @filter="filterChange"
          @sort="sortChange"
          @column="setColumn"
          :slots="['productCode', 'deviceBizType','bookingNum','shipperOrgName','action']"
          index
          @exChange="exChange"
          expand-row-keys
          expand
          :expandsKeyList="expands"
        >
          <template v-slot:productCode="scope">
            <custom-select
              url="productCodeSelectList"
              v-model="scope.row.productCode"
              :props="{ label: 'productCode', value: 'productCode' }"
              width="100%"
              :disabled="!!scope.row.deviceId"
            ></custom-select>
          </template>
          <template v-slot:deviceBizType="scope">
            <custom-select v-model="scope.row.deviceBizType" :disabled="!!scope.row.deviceId" code="dms_device_biz_type" :placeholder="$t('Common.com_please_select')"></custom-select>
          </template>
          <template v-slot:bookingNum="scope">
            <el-input v-model="scope.row.bookingNum" type="number" min="0" :disabled="!!scope.row.deviceId" style="width: 100%"></el-input>
          </template>
          <template v-slot:shipperOrgName="scope">
            <custom-select v-model="scope.row.shipOrgId"  :props="{ label: 'name', value: 'id' }" :dataFilter="shipperFilter" @change="onChangeShip(scope.row,scope.$index)"  :placeholder="$t('Common.com_please_select')"></custom-select>
          </template>
          <template v-slot:expand="scope">
            <div class="tab-wrap">
              <p class="expand-title">{{ $t('crm_contract_schemeSales_myself.xiao_shou_xin_xi') }}</p>
              <el-form :rules="rules" label-position="top" class="wrap-form">
                <el-row :gutter="15" class="wrap-form-row">
                  <template>
                    <el-col :span="4">
                      <el-form-item :label="$t('crm_contract_schemeSales_myself.xiao_shou_jin_e_tai')">
                        <el-input v-model="scope.row.unitPrice" class="amount" type="number" min="0" @input="handleEdit(...arguments,scope.row,'unitPrice')" style="width: 100%" :disabled="!scope.row.edit">
                          <template slot="prepend">
                            {{ scope.row.currencyUnit }}
                          </template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4" v-if="isShowhqProfit">
                      <el-form-item :label="$t('crm_contract_schemeSales_myself.zbysjet')">
                        <el-input v-model="scope.row.hqProfit" class="amount" type="number" min="0" @input="handleEdit(...arguments,scope.row,'hqProfit')" style="width: 100%" :disabled="!scope.row.edit">
                          <template slot="prepend">
                            {{ scope.row.currencyUnit }}
                          </template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4" v-if="isShowAfterServiceProfit">
                      <el-form-item :label="$t('crm_contract_schemeSales_myself.shysjet')">
                        <el-input v-model="scope.row.afterServiceProfit" class="amount" type="number" min="0" @input="handleEdit(...arguments,scope.row,'afterServiceProfit')" placeholder style="width: 100%" :disabled="!scope.row.edit">
                          <template slot="prepend">
                            {{ scope.row.currencyUnit }}
                          </template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item :label="$t('crm_contract_schemeSales_myself.shfwqxy')">
                        <el-input v-model="scope.row.serviceTerm" type="number"  min="0" @input="handleEdit(...arguments,scope.row,'serviceTerm')" style="width: 100%" :disabled="!scope.row.edit"></el-input>
                      </el-form-item>
                    </el-col>
                  </template>
                </el-row>
              </el-form>
            </div>
            <div class="tab-wrap">
              <p class="expand-title">{{$t('crm_contract_schemeSales_myself.shu_ju_fu_wu_fang_an')}}</p>
              <el-form :rules="rules" label-position="top" class="wrap-form">
                <el-row :gutter="15" class="wrap-form-row">
                  <!-- {{ scope.row.simService }} -->
                  <template>
                    <el-col :span="4">
                      <el-form-item :label="$t('crm_contract_schemeSales_myself.sfgmsjfw')">
                        <el-switch v-model="scope.row.isBuy" :active-value="1" :inactive-value="0" :disabled="!scope.row.edit" @change="onSimBuy(scope.row)"></el-switch>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item :label="$t('crm_contract_schemeSales_myself.shu_ju_fu_wu_fang_an')">
                        <custom-select
                          :disabled="`${scope.row.isBuy}`==='0'"
                          url="simServiceSelectList"
                          v-model="scope.row.simService.goodsSkuId"
                          :props="{ label: 'goodsName', value: 'goodsSkuId' }"
                          @change="onGoodsSkuId(...arguments,scope.row.simService)"
                          @getList="onInitGoods(...arguments,scope.row.simService)"
                          width="100%"
                        ></custom-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item :label="$t('crm_contract_schemeSales_myself.sjfwscy')">
                        <el-input v-model="scope.row.simService.serviceTerm" type="number" min="0" @change="onServiceTerm(scope.row.simService)" @input="handleEdit(...arguments,scope.row.simService,'serviceTerm')" style="width: 100%" :disabled="`${scope.row.isBuy}`==='0'">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item :label="$t('crm_contract_schemeSales_myself.jin_eooo', [scope.row.currencyUnit,scope.row.simService.unitPrice,scope.row.simService.unit])">
                        <el-input v-model="scope.row.simService.serviceAmount" :disabled="true" class="amount" style="width: 100%" >
                          <template slot="prepend">
                            {{ scope.row.currencyUnit }}
                          </template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </template>
                  <el-col :span="4" :offset="2">
                    <el-form-item :label="$t('Common.com_handle')">
                      <el-button type="text" size="mini" v-if="!scope.row.edit" @click="editItem(scope.row)">{{ $t('Common.com_edit') }}</el-button>
                      <el-button type="text" size="mini" v-if="scope.row.edit" @click="saveItem(scope.row)">{{ $t('Common.com_save') }}</el-button>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </template>
          <template v-slot:action="scope">
            <!-- 甲方和发货方一致要选  售后和甲方一致可选可不选 -->
            <el-button type="text" size="mini" @click="chooseDevice(scope.row,scope.$index)" v-if="contractInfo.partyAId===scope.row.shipOrgId">{{ $t('crm_contract_schemeSales_myself.xuan_ze_she_bei') }}</el-button>
            <el-button type="text" size="mini" @click="exChange(scope.row)">{{ $t('Common.com_edit') }}</el-button>
            <el-button type="text" size="mini" @click="deleteLeaseItem(scope.$index, scope.row)">{{ $t('Common.com_delete') }}</el-button>
          </template>
        </custom-table-expand>
        <!-- <el-button style="margin: 15px" type="primary" @click="addBenefitSharing()">{{ $t('com_add_to') }}</el-button> -->
      </div>
      <div class="lease-add-btn" @click="addLeaseItem">
        <div style="display: inline-block">
          <i class="icon icon-add"></i>
          <span>{{ $t('crm_contract_schemeSales_myself.tjxssb') }}</span>
        </div>
      </div>
    </div>
    <div class="btn-group">
      <el-button @click="onCancel">{{ $t('Common.com_cancel') }}</el-button>
      <el-button @click="preStep">{{ $t('crm_contract_schemeSales_myself.sybhtxx')}}</el-button>
      <template>
        <el-button type="primary" @click="saveScheme(true)" v-if="contractInfo.signingMethod === 2">{{ $t('crm_contract_schemeSales_myself.xybsczzht') }}</el-button>
        <el-button type="primary" @click="saveScheme(true)" v-if="contractInfo.signingMethod === 1">{{ $t('crm_contract_schemeSales_myself.xybxzdzht') }}</el-button>
      </template>
    </div>
    <!-- 选择方案 -->
    <contractSales-device-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="addLeaseList"></contractSales-device-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import customTableExpand from '@/components/customTableExpand.vue';
import contractSalesDeviceDialog from './contractSales_device_dialog.vue';
// import contractBreakDialog from './contract_scheme_break_dialog.vue';

export default {
  name: 'scheme_sales_myself',
  components: { customTableExpand, contractSalesDeviceDialog },
  props: {
    backType: { type: String, default: '' },
    lastOrderId: { type: String, default: '' },
    contractId: [String, Number],
    contractClass: [String, Number],
    operateFlag: [String, Number], // 唯一标识
  },
  inject: ['getContractInfo'],
  computed: {
    contractInfo() {
      return this.getContractInfo();
    },
    isShowhqProfit() {
      // JV ≠ HQ 时才显示 总部应收金额
      return this.contractInfo.partyAId !== this.contractInfo.hqId;
    },
    isShowAfterServiceProfit() {
      // 售后不等于甲方乙方总部才显示售后应收金额
      return this.contractInfo.hqId !== this.contractInfo.afterServiceId && this.contractInfo.customerId !== this.contractInfo.afterServiceId && this.contractInfo.partyAId !== this.contractInfo.afterServiceId;
    },
    isMyself() {
      return this.contractInfo.partyAId === this.contractInfo.afterServiceId;
    }
  },
  watch: {
    // contractInfo: function () {
    //   // console.log(this.contractInfo);
    //   // this.setContractInfo();
    // },
  },
  data() {
    return {
      tableCode: 'contract_sales_chooseDevice',
      // 服务中心
      form: {},
      rules: {},
      // 获取row的key值
      getRowKeys(row) {
        return row.index;
      },
      expands: [],
      isLoading: false,
      // 租赁方案
      leaseForm: {
        contractList: [],
        // 删除的
        deleteList: [],
      },
      formItem: {
        productCode: '',
        deviceId: '',
        deviceBizType: '',
        bookingNum: '',
        shipperOrgName: '',
        shipOrgId: '',
        unitPrice: '',
        hqProfit: 0,
        afterServiceProfit: 0,
        serviceTerm: '',
        currencyUnit: '¥',
        index: '',
        edit: false,
        isBuy: 1,
        // 数据服务方案
        simService: {

          goodsCode: '',
          goodsName: '',
          goodsSkuId: '',
          serviceTerm: '',
          unitPrice: '',
          currencyUnit: '',
          unit: '',
          specNames: '',
          serviceAmount: ''
        },
      },
      // 选择收货地址
      dialogVisible: false,
      dialogModel: {},
      deviceIndex: undefined,
      // 公司ID
      // contractId: '',
      // 售后公司列表
      allServiceList: [],
      leaseId: '',
      schemeInfo: {},
    };
  },
  mounted() {
    // this.factoryId = this.getJump('factoryId');
    // this.contractId = this.contractId || '';
    this.getSchemeDetail();
    // this.leaseForm.contractList.push(this.leaseItem);
  },
  methods: {
    shipperFilter() {
      const list = [];
      const hq = {
        id: this.contractInfo.hqId,
        name: this.contractInfo.hqName
      };
      list.push(hq);
      if (this.contractInfo.hqId !== this.contractInfo.afterServiceId) {
        const afterService = {
          id: this.contractInfo.afterServiceId,
          name: this.contractInfo.afterServiceName
        };
        list.push(afterService);
      }
      return list;
    },
    // 在 Input 值改变时触发
    handleEdit(val, row, key) {
      let value = val.replace(/[^\d]/g, ''); // 只能输入数字
      value = val.replace(/^0+(\d)/, '$1'); // 第一位0开头，0后面为数字，则过滤掉，取后面的数字
      if (value < 0) {
        value = 0; // 小于0的数改为0
      }
      row[key] = value;
    },
    getSchemeDetail: function () {
      if (!this.contractId) {
        return;
      }
      this.isLoading = true;
      this.$getJSON(apis.saleOrderListScheme, { bizId: this.contractId, bizClass: this.contractClass }).then((res) => {
        this.isLoading = false;
        const data = res.data.goodsList ? res.data.goodsList : [];
        data.forEach((i, index) => {
          i.index = index;
          i.edit = false;
          if (i.simService && Object.keys(i.simService).length > 0) {
            i.isBuy = 1;
          } else {
            i.isBuy = 0;
            i.simService = {
              goodsCode: '',
              goodsName: '',
              goodsSkuId: '',
              serviceTerm: '',
              unitPrice: '',
              currencyUnit: '',
              unit: '',
              specNames: '',
              serviceAmount: ''
            };
          }
        });
        this.leaseForm.contractList = data;
        this.schemeInfo = res.data;
      });
    },
    // 取消
    onCancel: function () {
      // this.jump('/contract/management', { refresh: true }, true);
      this.$emit('cancelJump');
    },
    // 选择方案弹窗回调
    addLeaseList: function (item) {
      // productCode
      // 修复数量为空 总额NAN

      const terms = 36 - (item.totalReceivedMonthHq||0) > 0 ? 36 - (item.totalReceivedMonthHq||0) : 0;

      this.$set(item, 'index', this.deviceIndex);
      this.$set(item, 'serviceTerm', terms);
      this.$set(item, 'edit', false);
      // 加载回来默认是展开的
      item.edit = true;

      // 去除重叠的型号
      // const concatArr = this.leaseForm.contractList.concat(list.filter(item => !this.leaseForm.contractList.find(inItem => inItem.deviceId === item.deviceId)));
      // this.leaseForm.contractList = concatArr;
      const pItem = { ...this.leaseForm.contractList[this.deviceIndex],
        deviceId: item.deviceId,
        bodyNum: item.bodyNum,
        productCode: item.productCode,
        bookingNum: 1,
        serviceTerm: item.serviceTerm,
        deviceBizType: item.deviceBizType,
        departureTime: item.departureTime,
        totalReceivedRentalHq: item.totalReceivedRentalHq,
        totalReceivedRentalJv: item.totalReceivedRentalJv,
        totalReceivedRentalSc: item.totalReceivedRentalSc,
        totalReceivedMonthHq: item.totalReceivedMonthHq,
        index: this.deviceIndex,
      };
      this.$set(this.leaseForm.contractList, this.deviceIndex, pItem);
      if (item) {
        this.expands = [];
        this.expands.push(item.index);
      }
      // this.onRowExpansion(list);
    },
    // 租赁方案
    saveScheme: function (flag) {

      // 方案表单验证
      const hasEmpty = this.leaseForm.contractList.find(t => t.productCode === '' || t.deviceBizType === '' || t.shipOrgId === '' || t.unitPrice === '' || (t.hqProfit === '' && this.isShowhqProfit));
      if (hasEmpty) {
        this.$message.error(this.$t('crm_contract_schemeSales_myself.qjzlfatxwz'));
        return;
      }
      // 要选择设备的验证
      const hasServicePlanEmpty = this.leaseForm.contractList.find(t => `${t.isBuy}` === '1' && (t.simService.goodsSkuId === '' || t.simService.serviceTerm === ''));
      if (hasServicePlanEmpty) {
        this.$message.error(this.$t('crm_contract_schemeSales_myself.qbsjfwfatxwz'));
        return;
      }
      // 设备数量不能小于0
      const negativeTotal = this.leaseForm.contractList.find(t => +t.bookingNum <= 0);
      if (negativeTotal) {
        this.$message.error(this.$t('crm_contract_schemeSales_myself.sbslbnxy0'));
        return;
      }
      // 金额不能小于0
      const priceThan = this.leaseForm.contractList.find(t => +t.hqProfit < 0);
      if (priceThan) {
        this.$message.error(this.$t('crm_contract_schemeSales_myself.zbysjebnxy0'));
        return;
      }
      // 金额不能小于0
      const unitPriceThan = this.leaseForm.contractList.find(t => +t.unitPrice < 0);
      if (unitPriceThan) {
        this.$message.error(this.$t('crm_contract_schemeSales_myself.xsjebnxy0'));
        return;
      }
      const unitPpriceThan = this.leaseForm.contractList.find(t => +t.unitPrice < +t.hqProfit || +t.unitPrice < +t.afterServiceProfit);
      if (unitPpriceThan) {
        this.$message.error(this.$t('crm_contract_schemeSales_myself.zbyshshysbndyxsje'));
        return;
      }
      const serviceTermThan = this.leaseForm.contractList.find(t => +t.serviceTerm < 0);
      if (serviceTermThan) {
        this.$message.error(this.$t('crm_contract_schemeSales_myself.shfwqxbnxy0'));
        return;
      }
      // 甲方=发货方 并且甲方不等于总部时 必选
      const deviceEmpty = this.leaseForm.contractList.find(t => !t.deviceId && (this.contractInfo.partyAId === t.shipOrgId && this.contractInfo.hqId !== this.contractInfo.partyAId));
      if (deviceEmpty) {
        this.$message.error(this.$t('crm_contract_schemeSales_myself.qing_xuan_ze_she_bei'));
        return;
      }
      // 选择方案
      const length = this.leaseForm.contractList.length;
      if (length <= '0') {
        this.$message.error(this.$t('crm_contract_schemeSales_myself.qtjxssb'));
        return;
      }

      // 不购买数据服务方案制空
      const contractList = this.leaseForm.contractList.map((t) => {
        if (`${t.isBuy}` === '0') {
          // t.simService = null;
          return { ...t, simService: null };
        } else {
          return t;
        }
      });
      // this.form.operateFlag = this.operateFlag;
      // this.leaseForm.contractList.forEach((item) => {
      //   item.operateFlag = this.operateFlag;
      //   // 期数
      //   item.periodNum = Math.ceil(item.rentalTerm / item.paymentPeriodSlef);
      //   // 组件加附加费
      //   item.cost = (parseFloat(item.unitPrice, 10) + parseFloat(item.additionalFee, 10)).toFixed(2);
      //   // 首期租金/台
      //   item.firstRent = (item.cost * item.paymentPeriodSlef).toFixed(2);
      //   // 累计租金/台
      //   item.totalRent = (item.cost * item.rentalTerm).toFixed(2);
      //   // 首期租金(合计)
      //   item.firstRentTotal = parseFloat(item.firstRent * item.bookingNum).toFixed(2);
      //   // 累计押金
      //   item.depositFeeTotal = parseFloat(item.depositFee * item.bookingNum).toFixed(2);
      //   // 首期需支付
      //   item.firstPay = parseFloat(item.firstRentTotal + item.depositFeeTotal).toFixed(2);
      //   // item.bizClass = this.contractClass;
      //   // item.bizId = this.contractId;
      // });
      // 保存更改租赁方案
      this.$postJSON(apis.saleOrderSaveScheme, {
        bizClass: this.contractClass,
        bizId: this.contractId,
        operateFlag: this.operateFlag,
        goodsList: [...contractList, ...this.leaseForm.deleteList],
      }).then(() => {
        if (flag) {
          this.$message({
            message: this.$t('Common.com_save_success'),
            type: 'success',
          });
          // 上传纸质合同
          this.$emit('success', 5);
        } else {
          this.getSchemeDetail();
        }
      });
    },
    // 新增方案弹窗
    addLeaseItem: function () {
      this.formItem.index = this.leaseForm.contractList.length;
      this.leaseForm.contractList.push(JSON.parse(JSON.stringify(this.formItem)));
      this.$nextTick(() => {
        this.expands = [];
        this.expands.push(this.formItem.index);
        this.leaseForm.contractList[this.leaseForm.contractList.length - 1].edit = true;
      });
    },
    chooseDevice: function (row, index) {
      this.deviceIndex = index;
      this.dialogModel.title = this.$t('crm_contract_schemeSales_myself.xuan_ze_she_bei');
      this.dialogModel.productCode = row.productCode;
      this.dialogModel.deviceBizType = row.deviceBizType;
      this.dialogVisible = true;
    },
    onChangeShip(item, index) {
      this.deviceIndex = index;
      if (Object.keys(item).length > 0 && this.contractInfo.partyAId === item.shipOrgId) {
        item.bookingNum = 1;
        item.index = this.deviceIndex;
        item.edit = true;
      } else {
        item.bookingNum = 1;
        item.deviceId = this.formItem.deviceId;
        item.bodyNum = this.formItem.bodyNum;
        item.serviceTerm = this.formItem.serviceTerm;
        item.departureTime = this.formItem.departureTime;
        item.totalReceivedRentalHq = this.formItem.totalReceivedRentalHq;
        item.totalReceivedRentalJv = this.formItem.totalReceivedRentalJv;
        item.totalReceivedRentalSc = this.formItem.totalReceivedRentalSc;
        item.totalReceivedMonthHq = this.formItem.totalReceivedMonthHq;
        item.index = this.deviceIndex;
        item.edit = true;
      }

    },
    onSimBuy() {
      // if (`${row.isBuy}` !== '1') {
      //   row.simService = null;
      // } else {
      //   row.simService = {
      //     goodsCode: '',
      //     goodsName: '',
      //     goodsSkuId: '',
      //     serviceTerm: '',
      //     unitPrice: ''
      //   };
      // }
    },
    onInitGoods(list, item) {
    // 迭代20231218-默认选择 “数据流量套餐A 30M 免费”和 “0”月
      if (!item.goodsSkuId) {
        const freeItem = list.find(i => `${i.unitPrice}` === '0');
        if (freeItem) {
          item.goodsSkuId = freeItem.goodsSkuId;
          item.goodsCode = freeItem.goodsCode;
          item.goodsName = freeItem.goodsName;
          item.unitPrice = freeItem.unitPrice;
          item.currencyUnit = freeItem.currencyUnit;
          item.unit = freeItem.unit;
          item.specNames = freeItem.specNames;
          item.serviceTerm = 0;
          item.serviceAmount = 0;
        }
      }
    },

    onGoodsSkuId(item, simService) {
      simService.goodsCode = item.goodsCode;
      simService.goodsName = item.goodsName;
      simService.unitPrice = item.unitPrice;
      simService.currencyUnit = item.currencyUnit;
      simService.unit = item.unit;
      simService.specNames = item.specNames;
      simService.serviceTerm = '';
      simService.serviceAmount = '';
    },
    onServiceTerm(item) {
      item.serviceAmount = this.$toFixed(item.serviceTerm * item.unitPrice);
    },
    // 选择方案弹窗回调
    // 编辑方案
    editItem: function (item) {
      item.edit = true;
    },
    // 展开
    exChange: function (row) {
      this.expands = [];
      this.expands.push(row.index);
      row.edit = true;
    },
    // 保存方案
    saveItem: function (item) {
      item.edit = false;
      // this.expands = [];
      this.saveScheme(false);
    },
    // 删除方案项
    deleteLeaseItem: function (index, row) {
      this.leaseForm.contractList.splice(index, 1);
      this.leaseForm.deleteList.push({ ...row, isDeleted: true });
    },
    preStep: function () {
      this.$emit('previous');
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
.content-scheme {
  padding: 14px 24px 0;
  .pay-info {
    display: flex;
    justify-content: flex-end;
    line-height: 36px;
    color: #495057;
    font-size: 12px;
    font-weight: 500;
    margin-top: 10px;
    & > div {
      margin-left: 20px;
      margin-right: 10px;
      span {
        color: red;
        font-size: 14px;
      }
    }
  }
  table {
    border-collapse: collapse;
  }
  .el-table .cell {
    // color: #FFFFFF;

    color: rgba(57, 70, 104, 1);
  }
  .el-table .el-table__row td {
    // display: inline-block;
    // width: 100%;
    margin-top: 16px;
    // background: #f5f5fa;
    color: rgba(57, 70, 104, 1);
    border: 0 !important;
  }
  .el-table tr {
    // background: #f5f5fa;
    border: 1px solid #f2f3fb;
    color: rgba(57, 70, 104, 1);
    th .cell {
      color: #636e78;
    }
  }
  .el-table__expanded-cell[class*='cell'] {
    padding: 0;
  }
  .tab-wrap {
    // padding: 0 24px;
    .expand-title{
      padding: 10px 24px 0;
      color: #00afff;
      font-size: 12px;
    }
    .wrap-form {
      background: #ffffff;
      padding: 10px 24px 0;
      .wrap-form-row {
        background: #ffffff;
        padding: 10px 14px 0;
        background: #f8f9fb;

        .amount{
          .el-input-group__prepend,.el-input__inner{
            color: red;
            font-weight: bold;
          }
        }
      }

    }

  }

  .lease-add-btn {
    line-height: 50px;
    text-align: center;
    color: rgba(73, 80, 87, 1);
    font-size: 12px;
    margin: 16px 0 16px;
    height: 50px;
    background: #f6f7fb;
    border: 1px dashed rgba(53, 184, 224, 0.3);
    cursor: pointer;
    span {
      line-height: 50px;
    }
    .icon {
      color: #00afff;
      font-size: 12px;
      margin-right: 8px;
      display: inline-block;
      line-height: 50px;
      height: 50px;
      // float: left;
    }
  }
}
</style>
